import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface ContactRole {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  contact_roles: ContactRole[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/contact_roles" },
  { title: "Contact Roles", href: "/admin/contact_roles" },
]

export default function Index({ contact_roles }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This role is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this role?"

    if (confirm(message)) {
      router.delete(`/admin/contact_roles/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Contact Roles" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Contact Roles</h1>
          <Link
            href="/admin/contact_roles/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Role
          </Link>
        </div>

        {contact_roles.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {contact_roles.map((cr) => (
                <tr key={cr.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {cr.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {cr.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {cr.usage_count > 0 ? cr.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/contact_roles/${cr.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(cr.id, cr.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No contact roles found.</p>
        )}
      </div>
    </AppLayout>
  )
}
